import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';

@observer
export class EditLicenseForm extends Modal {
  render() {
    const { editLicenseFormStore, SelectLicense } = modalStore.props.projectApp;
    const {
      conf: { formTitle },
    } = editLicenseFormStore;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={editLicenseFormStore}
          formTitle=''
          buttonHandler={SelectLicense}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
